import { Box, Grid, Paper, Typography } from "@material-ui/core";
import Controls from "../../../../components/controls/Controls";
import FormBase from "../../../../forms/FormBase";
import AttachmentForm from "../../../../forms/medicoTerceiro/AttachmentForm";
import FormFieldAttachmentBase, {
  FieldAttachment,
} from "../../../../forms/FormFieldAttachmentBase";

interface IMedicoTerceiroAttachmentDataComponentProps {
  MedicoTerceiroAttachmentForm: AttachmentForm;
  onInputChange: (
    name: string,
    form: FormBase,
    fieldAttachment: FieldAttachment,
    formField: FormFieldAttachmentBase
  ) => void;
  onDeleteFile: (
    name: string,
    form: FormBase,
    fieldAttachment: FieldAttachment,
    formField: FormFieldAttachmentBase
  ) => void;
}

export default function MedicoTerceiroAttachmentDataComponent(
  props: IMedicoTerceiroAttachmentDataComponentProps
) {
  return (
    <div>
      <Grid container spacing={10}>
        <Grid item xs={6}>
          <Grid container spacing={5}>
            <Grid item xs={12}>
              <Controls.Attachment
                label="Atestado de Capacidade Física e Cognitiva *"
                name="AtestadoCapacidadeFisicaCognitiva"
                limitedFiles={
                  props.MedicoTerceiroAttachmentForm
                    .AtestadoCapacidadeFisicaCognitiva.LimitedFiles
                }
                typeFiles={"image/*, .pdf"}
                values={
                  props.MedicoTerceiroAttachmentForm
                    .AtestadoCapacidadeFisicaCognitiva.Values
                }
                error={
                  props.MedicoTerceiroAttachmentForm
                    .AtestadoCapacidadeFisicaCognitiva.Error
                }
                onDeleteFile={(fieldAttachment: FieldAttachment) => {
                  props.onDeleteFile(
                    "AtestadoCapacidadeFisicaCognitiva",
                    props.MedicoTerceiroAttachmentForm,
                    fieldAttachment,
                    props.MedicoTerceiroAttachmentForm
                      .AtestadoCapacidadeFisicaCognitiva
                  );
                }}
                onChange={(fieldAttachment: FieldAttachment) => {
                  props.onInputChange(
                    "AtestadoCapacidadeFisicaCognitiva",
                    props.MedicoTerceiroAttachmentForm,
                    fieldAttachment,
                    props.MedicoTerceiroAttachmentForm
                      .AtestadoCapacidadeFisicaCognitiva
                  );
                }}
              />
            </Grid>

            <Grid item xs={12}>
              <Controls.Attachment
                label="Carteira de Vacinação atualizada"
                infoMessage="Em caso de recusa, favor preencher o Termo disponível na última página da solicitação"
                name="CarteiraVacinacaoOuTermo"
                limitedFiles={
                  props.MedicoTerceiroAttachmentForm.CarteiraVacinacaoOuTermo
                    .LimitedFiles
                }
                typeFiles={"image/*, .pdf"}
                values={
                  props.MedicoTerceiroAttachmentForm.CarteiraVacinacaoOuTermo
                    .Values
                }
                error={
                  props.MedicoTerceiroAttachmentForm.CarteiraVacinacaoOuTermo
                    .Error
                }
                onDeleteFile={(fieldAttachment: FieldAttachment) => {
                  props.onDeleteFile(
                    "CarteiraVacinacaoOuTermo",
                    props.MedicoTerceiroAttachmentForm,
                    fieldAttachment,
                    props.MedicoTerceiroAttachmentForm.CarteiraVacinacaoOuTermo
                  );
                }}
                onChange={(fieldAttachment: FieldAttachment) => {
                  props.onInputChange(
                    "CarteiraVacinacaoOuTermo",
                    props.MedicoTerceiroAttachmentForm,
                    fieldAttachment,
                    props.MedicoTerceiroAttachmentForm.CarteiraVacinacaoOuTermo
                  );
                }}
              />
            </Grid>

            <Grid item xs={12}>
              <Controls.Attachment
                label="Certidão de Ética Profissional (emitida pelo site do CREMESP)*"
                name="CertidaoEticaProfissional"
                limitedFiles={
                  props.MedicoTerceiroAttachmentForm.CertidaoEticaProfissional
                    .LimitedFiles
                }
                typeFiles={"image/*, .pdf"}
                values={
                  props.MedicoTerceiroAttachmentForm.CertidaoEticaProfissional
                    .Values
                }
                error={
                  props.MedicoTerceiroAttachmentForm.CertidaoEticaProfissional
                    .Error
                }
                onDeleteFile={(fieldAttachment: FieldAttachment) => {
                  props.onDeleteFile(
                    "CertidaoEticaProfissional",
                    props.MedicoTerceiroAttachmentForm,
                    fieldAttachment,
                    props.MedicoTerceiroAttachmentForm.CertidaoEticaProfissional
                  );
                }}
                onChange={(fieldAttachment: FieldAttachment) => {
                  props.onInputChange(
                    "CertidaoEticaProfissional",
                    props.MedicoTerceiroAttachmentForm,
                    fieldAttachment,
                    props.MedicoTerceiroAttachmentForm.CertidaoEticaProfissional
                  );
                }}
              />
            </Grid>

            <Grid item xs={12}>
              <Controls.Attachment
                label="Certidão de Quitação *"
                name="CertidaoQuitacao"
                limitedFiles={
                  props.MedicoTerceiroAttachmentForm.CertidaoQuitacao.LimitedFiles
                }
                typeFiles={"image/*, .pdf"}
                values={
                  props.MedicoTerceiroAttachmentForm.CertidaoQuitacao.Values
                }
                error={props.MedicoTerceiroAttachmentForm.CertidaoQuitacao.Error}
                onDeleteFile={(fieldAttachment: FieldAttachment) => {
                  props.onDeleteFile(
                    "CertidaoQuitacao",
                    props.MedicoTerceiroAttachmentForm,
                    fieldAttachment,
                    props.MedicoTerceiroAttachmentForm.CertidaoQuitacao
                  );
                }}
                onChange={(fieldAttachment: FieldAttachment) => {
                  props.onInputChange(
                    "CertidaoQuitacao",
                    props.MedicoTerceiroAttachmentForm,
                    fieldAttachment,
                    props.MedicoTerceiroAttachmentForm.CertidaoQuitacao
                  );
                }}
              />
            </Grid>

            <Grid item xs={12}>
              <Controls.Attachment
                label="Cópia da Carteira do Conselho *"
                name="CopiaCRM"
                limitedFiles={
                  props.MedicoTerceiroAttachmentForm.CopiaCRM.LimitedFiles
                }
                typeFiles={"image/*, .pdf"}
                values={props.MedicoTerceiroAttachmentForm.CopiaCRM.Values}
                error={props.MedicoTerceiroAttachmentForm.CopiaCRM.Error}
                onDeleteFile={(fieldAttachment: FieldAttachment) => {
                  props.onDeleteFile(
                    "CopiaCRM",
                    props.MedicoTerceiroAttachmentForm,
                    fieldAttachment,
                    props.MedicoTerceiroAttachmentForm.CopiaCRM
                  );
                }}
                onChange={(fieldAttachment: FieldAttachment) => {
                  props.onInputChange(
                    "CopiaCRM",
                    props.MedicoTerceiroAttachmentForm,
                    fieldAttachment,
                    props.MedicoTerceiroAttachmentForm.CopiaCRM
                  );
                }}
              />
            </Grid>

            <Grid item xs={12}>
              <Controls.Attachment
                label="Carta de Apresentação do Médico Responsável pelo Serviço *"
                name="CartaApresentacaoMedicoResponsavelPeloServico"
                limitedFiles={props.MedicoTerceiroAttachmentForm.CartaApresentacaoMedicoResponsavelPeloServico.LimitedFiles}
                typeFiles={"image/*, .pdf"}
                values={props.MedicoTerceiroAttachmentForm.CartaApresentacaoMedicoResponsavelPeloServico.Values}
                error={props.MedicoTerceiroAttachmentForm.CartaApresentacaoMedicoResponsavelPeloServico.Error}
                onDeleteFile={(fieldAttachment: FieldAttachment) => {
                  props.onDeleteFile(
                    "CartaApresentacaoMedicoResponsavelPeloServico",
                    props.MedicoTerceiroAttachmentForm,
                    fieldAttachment,
                    props.MedicoTerceiroAttachmentForm.CartaApresentacaoMedicoResponsavelPeloServico
                  );
                }}
                onChange={(fieldAttachment: FieldAttachment) => {
                  props.onInputChange(
                    "CartaApresentacaoMedicoResponsavelPeloServico",
                    props.MedicoTerceiroAttachmentForm,
                    fieldAttachment,
                    props.MedicoTerceiroAttachmentForm.CartaApresentacaoMedicoResponsavelPeloServico
                  );
                }}
              />
            </Grid>

            <Grid item xs={12}>
              <Controls.Attachment
                label="Comprovante de Vacinação COVID19"
                name="ComprovanteVacinaCovid"
                limitedFiles={props.MedicoTerceiroAttachmentForm.ComprovanteVacinaCovid.LimitedFiles}
                typeFiles={"image/*, .pdf"}
                values={props.MedicoTerceiroAttachmentForm.ComprovanteVacinaCovid.Values}
                error={props.MedicoTerceiroAttachmentForm.ComprovanteVacinaCovid.Error}
                onDeleteFile={(fieldAttachment: FieldAttachment) => {
                  props.onDeleteFile(
                    "ComprovanteVacinaCovid",
                    props.MedicoTerceiroAttachmentForm,
                    fieldAttachment,
                    props.MedicoTerceiroAttachmentForm.ComprovanteVacinaCovid
                  );
                }}
                onChange={(fieldAttachment: FieldAttachment) => {
                  props.onInputChange(
                    "ComprovanteVacinaCovid",
                    props.MedicoTerceiroAttachmentForm,
                    fieldAttachment,
                    props.MedicoTerceiroAttachmentForm.ComprovanteVacinaCovid
                  );
                }}
              />
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={6}>
          <Grid container spacing={5}>
            <Grid item xs={12}>
              <Controls.Attachment
                label="Cópia do RG *"
                name="CopiaRG"
                limitedFiles={
                  props.MedicoTerceiroAttachmentForm.CopiaRG.LimitedFiles
                }
                typeFiles={"image/*, .pdf"}
                values={props.MedicoTerceiroAttachmentForm.CopiaRG.Values}
                error={props.MedicoTerceiroAttachmentForm.CopiaRG.Error}
                onDeleteFile={(fieldAttachment: FieldAttachment) => {
                  props.onDeleteFile(
                    "CopiaRG",
                    props.MedicoTerceiroAttachmentForm,
                    fieldAttachment,
                    props.MedicoTerceiroAttachmentForm.CopiaRG
                  );
                }}
                onChange={(fieldAttachment: FieldAttachment) => {
                  props.onInputChange(
                    "CopiaRG",
                    props.MedicoTerceiroAttachmentForm,
                    fieldAttachment,
                    props.MedicoTerceiroAttachmentForm.CopiaRG
                  );
                }}
              />
            </Grid>

            <Grid item xs={12}>
              <Controls.Attachment
                label="Currículo resumido atualizado *"
                name="CurriculoResumidoAtualizado"
                limitedFiles={
                  props.MedicoTerceiroAttachmentForm.CurriculoResumidoAtualizado
                    .LimitedFiles
                }
                typeFiles={"image/*, .pdf"}
                values={
                  props.MedicoTerceiroAttachmentForm.CurriculoResumidoAtualizado
                    .Values
                }
                error={
                  props.MedicoTerceiroAttachmentForm.CurriculoResumidoAtualizado
                    .Error
                }
                onDeleteFile={(fieldAttachment: FieldAttachment) => {
                  props.onDeleteFile(
                    "CurriculoResumidoAtualizado",
                    props.MedicoTerceiroAttachmentForm,
                    fieldAttachment,
                    props.MedicoTerceiroAttachmentForm.CurriculoResumidoAtualizado
                  );
                }}
                onChange={(fieldAttachment: FieldAttachment) => {
                  props.onInputChange(
                    "CurriculoResumidoAtualizado",
                    props.MedicoTerceiroAttachmentForm,
                    fieldAttachment,
                    props.MedicoTerceiroAttachmentForm.CurriculoResumidoAtualizado
                  );
                }}
              />
            </Grid>

            <Grid item xs={12}>
              <Controls.Attachment
                label="Uma foto 3x4 fundo branco *"
                name="Foto"
                limitedFiles={
                  props.MedicoTerceiroAttachmentForm.Foto.LimitedFiles
                }
                typeFiles={"image/*, .pdf"}
                values={props.MedicoTerceiroAttachmentForm.Foto.Values}
                error={props.MedicoTerceiroAttachmentForm.Foto.Error}
                onDeleteFile={(fieldAttachment: FieldAttachment) => {
                  props.onDeleteFile(
                    "Foto",
                    props.MedicoTerceiroAttachmentForm,
                    fieldAttachment,
                    props.MedicoTerceiroAttachmentForm.Foto
                  );
                }}
                onChange={(fieldAttachment: FieldAttachment) => {
                  props.onInputChange(
                    "Foto",
                    props.MedicoTerceiroAttachmentForm,
                    fieldAttachment,
                    props.MedicoTerceiroAttachmentForm.Foto
                  );
                }}
              />
            </Grid>

            <Grid item xs={12}>
              <Controls.Attachment
                label="Declaração de Conflitos - Anexo *"
                name="DeclaracaoConflitos"
                limitedFiles={
                  props.MedicoTerceiroAttachmentForm.DeclaracaoConflitos
                    .LimitedFiles
                }
                typeFiles={"image/*, .pdf"}
                values={
                  props.MedicoTerceiroAttachmentForm.DeclaracaoConflitos.Values
                }
                error={
                  props.MedicoTerceiroAttachmentForm.DeclaracaoConflitos.Error
                }
                onDeleteFile={(fieldAttachment: FieldAttachment) => {
                  props.onDeleteFile(
                    "DeclaracaoConflitos",
                    props.MedicoTerceiroAttachmentForm,
                    fieldAttachment,
                    props.MedicoTerceiroAttachmentForm.DeclaracaoConflitos
                  );
                }}
                onChange={(fieldAttachment: FieldAttachment) => {
                  props.onInputChange(
                    "DeclaracaoConflitos",
                    props.MedicoTerceiroAttachmentForm,
                    fieldAttachment,
                    props.MedicoTerceiroAttachmentForm.DeclaracaoConflitos
                  );
                }}
              />
            </Grid>

            <Grid item xs={12}>
              <Controls.Attachment
                label="Cópia do Diploma de Graduação em Medicina *"
                name="CopiaDiplomaGraduacaoMedicina"
                limitedFiles={
                  props.MedicoTerceiroAttachmentForm.CopiaDiplomaGraduacaoMedicina
                    .LimitedFiles
                }
                typeFiles={"image/*, .pdf"}
                values={
                  props.MedicoTerceiroAttachmentForm.CopiaDiplomaGraduacaoMedicina
                    .Values
                }
                error={
                  props.MedicoTerceiroAttachmentForm.CopiaDiplomaGraduacaoMedicina
                    .Error
                }
                onDeleteFile={(fieldAttachment: FieldAttachment) => {
                  props.onDeleteFile(
                    "CopiaDiplomaGraduacaoMedicina",
                    props.MedicoTerceiroAttachmentForm,
                    fieldAttachment,
                    props.MedicoTerceiroAttachmentForm
                      .CopiaDiplomaGraduacaoMedicina
                  );
                }}
                onChange={(fieldAttachment: FieldAttachment) => {
                  props.onInputChange(
                    "CopiaDiplomaGraduacaoMedicina",
                    props.MedicoTerceiroAttachmentForm,
                    fieldAttachment,
                    props.MedicoTerceiroAttachmentForm
                      .CopiaDiplomaGraduacaoMedicina
                  );
                }}
              />
            </Grid>

            <Grid item xs={12}>
              <Controls.Attachment
                label="Registro de Qualificação de Especialista (RQE)"
                name="RegistroQualificacaoEspecialistaRQE"
                limitedFiles={
                  props.MedicoTerceiroAttachmentForm.RegistroQualificacaoEspecialistaRQE
                    .LimitedFiles
                }
                typeFiles={"image/*, .pdf"}
                values={
                  props.MedicoTerceiroAttachmentForm.RegistroQualificacaoEspecialistaRQE
                    .Values
                }
                error={
                  props.MedicoTerceiroAttachmentForm.RegistroQualificacaoEspecialistaRQE
                    .Error
                }
                onDeleteFile={(fieldAttachment: FieldAttachment) => {
                  props.onDeleteFile(
                    "RegistroQualificacaoEspecialistaRQE",
                    props.MedicoTerceiroAttachmentForm,
                    fieldAttachment,
                    props.MedicoTerceiroAttachmentForm
                      .RegistroQualificacaoEspecialistaRQE
                  );
                }}
                onChange={(fieldAttachment: FieldAttachment) => {
                  props.onInputChange(
                    "RegistroQualificacaoEspecialistaRQE",
                    props.MedicoTerceiroAttachmentForm,
                    fieldAttachment,
                    props.MedicoTerceiroAttachmentForm
                      .RegistroQualificacaoEspecialistaRQE
                  );
                }}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <br />
      <br />

      <Paper variant="outlined">
        <Box p={1}>
          <Typography variant="subtitle1" gutterBottom component="div">
            Cópia do Título de Especialista ou Residência Médica *
          </Typography>

          <Grid container spacing={10}>
            <Grid item xs={6}>
              <Grid container spacing={5}>
                <Grid item xs={12}>
                  <Controls.Attachment
                    label="Título de Especialista"
                    name="CopiaTituloEspecialista"
                    limitedFiles={
                      props.MedicoTerceiroAttachmentForm.CopiaTituloEspecialista
                        .LimitedFiles
                    }
                    typeFiles={"image/*, .pdf"}
                    values={
                      props.MedicoTerceiroAttachmentForm.CopiaTituloEspecialista
                        .Values
                    }
                    error={
                      props.MedicoTerceiroAttachmentForm.CopiaTituloEspecialista
                        .Error
                    }
                    onDeleteFile={(fieldAttachment: FieldAttachment) => {
                      props.onDeleteFile(
                        "CopiaTituloEspecialista",
                        props.MedicoTerceiroAttachmentForm,
                        fieldAttachment,
                        props.MedicoTerceiroAttachmentForm.CopiaTituloEspecialista
                      );
                    }}
                    onChange={(fieldAttachment: FieldAttachment) => {
                      props.onInputChange(
                        "CopiaTituloEspecialista",
                        props.MedicoTerceiroAttachmentForm,
                        fieldAttachment,
                        props.MedicoTerceiroAttachmentForm.CopiaTituloEspecialista
                      );
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={6}>
              <Grid container spacing={5}>
                <Grid item xs={12}>
                  <Controls.Attachment
                    label="Residência Médica"
                    name="CopiaResidenciaMedica"
                    limitedFiles={
                      props.MedicoTerceiroAttachmentForm.CopiaResidenciaMedica
                        .LimitedFiles
                    }
                    typeFiles={"image/*, .pdf"}
                    values={
                      props.MedicoTerceiroAttachmentForm.CopiaResidenciaMedica
                        .Values
                    }
                    error={
                      props.MedicoTerceiroAttachmentForm.CopiaResidenciaMedica
                        .Error
                    }
                    onDeleteFile={(fieldAttachment: FieldAttachment) => {
                      props.onDeleteFile(
                        "CopiaResidenciaMedica",
                        props.MedicoTerceiroAttachmentForm,
                        fieldAttachment,
                        props.MedicoTerceiroAttachmentForm.CopiaResidenciaMedica
                      );
                    }}
                    onChange={(fieldAttachment: FieldAttachment) => {
                      props.onInputChange(
                        "CopiaResidenciaMedica",
                        props.MedicoTerceiroAttachmentForm,
                        fieldAttachment,
                        props.MedicoTerceiroAttachmentForm.CopiaResidenciaMedica
                      );
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <br />
          <Typography variant="caption" display="block" gutterBottom>
            Obs.: Pode ser anexado um arquivo.
          </Typography>
        </Box>
      </Paper>

      <br />
      <br />

      <Paper variant="outlined">
        <Box p={1}>
          <Typography variant="subtitle1" gutterBottom component="div">
            Cópia dos certificados do curso de reanimação
          </Typography>

          <Grid container spacing={10}>
            <Grid item xs={6}>
              <Grid container spacing={5}>
                <Grid item xs={12}>
                  <Controls.Attachment
                    label="Treinamento ACLS"
                    name="CopiaCertificadosCursoReanimacaoTreinamentoACLS"
                    limitedFiles={
                      props.MedicoTerceiroAttachmentForm
                        .CopiaCertificadosCursoReanimacaoTreinamentoACLS
                        .LimitedFiles
                    }
                    typeFiles={"image/*, .pdf"}
                    values={
                      props.MedicoTerceiroAttachmentForm
                        .CopiaCertificadosCursoReanimacaoTreinamentoACLS.Values
                    }
                    error={
                      props.MedicoTerceiroAttachmentForm
                        .CopiaCertificadosCursoReanimacaoTreinamentoACLS.Error
                    }
                    onDeleteFile={(fieldAttachment: FieldAttachment) => {
                      props.onDeleteFile(
                        "CopiaCertificadosCursoReanimacaoTreinamentoACLS",
                        props.MedicoTerceiroAttachmentForm,
                        fieldAttachment,
                        props.MedicoTerceiroAttachmentForm
                          .CopiaCertificadosCursoReanimacaoTreinamentoACLS
                      );
                    }}
                    onChange={(fieldAttachment: FieldAttachment) => {
                      props.onInputChange(
                        "CopiaCertificadosCursoReanimacaoTreinamentoACLS",
                        props.MedicoTerceiroAttachmentForm,
                        fieldAttachment,
                        props.MedicoTerceiroAttachmentForm
                          .CopiaCertificadosCursoReanimacaoTreinamentoACLS
                      );
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={6}>
              <Grid container spacing={5}>
                <Grid item xs={12}>
                  <Controls.Attachment
                    label="Treinamento PALS"
                    name="CopiaCertificadosCursoReanimacaoTreinamentoPALS"
                    limitedFiles={
                      props.MedicoTerceiroAttachmentForm
                        .CopiaCertificadosCursoReanimacaoTreinamentoPALS
                        .LimitedFiles
                    }
                    typeFiles={"image/*, .pdf"}
                    values={
                      props.MedicoTerceiroAttachmentForm
                        .CopiaCertificadosCursoReanimacaoTreinamentoPALS.Values
                    }
                    error={
                      props.MedicoTerceiroAttachmentForm
                        .CopiaCertificadosCursoReanimacaoTreinamentoPALS.Error
                    }
                    onDeleteFile={(fieldAttachment: FieldAttachment) => {
                      props.onDeleteFile(
                        "CopiaCertificadosCursoReanimacaoTreinamentoPALS",
                        props.MedicoTerceiroAttachmentForm,
                        fieldAttachment,
                        props.MedicoTerceiroAttachmentForm
                          .CopiaCertificadosCursoReanimacaoTreinamentoPALS
                      );
                    }}
                    onChange={(fieldAttachment: FieldAttachment) => {
                      props.onInputChange(
                        "CopiaCertificadosCursoReanimacaoTreinamentoPALS",
                        props.MedicoTerceiroAttachmentForm,
                        fieldAttachment,
                        props.MedicoTerceiroAttachmentForm
                          .CopiaCertificadosCursoReanimacaoTreinamentoPALS
                      );
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <br />
          <Typography variant="caption" display="block" gutterBottom>
            Obs.: Pode ser anexado um arquivo.
          </Typography>
        </Box>
      </Paper>
    </div>
  );
}
